"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AssociationsStorage {
    constructor() {
        this.storage = {};
    }
    get(name, id) {
        if (!this.areArgumentsCorrect(name, id) || !this.isContained(name, id)) {
            return new Set();
        }
        return this.storage[name][id];
    }
    add(item, name, id) {
        if (!this.areArgumentsCorrect(name, id)) {
            this.throwError(name, id);
        }
        if (!this.storage[name]) {
            this.storage[name] = {};
        }
        if (!this.storage[name][id]) {
            this.storage[name][id] = new Set();
        }
        this.storage[name][id].add(item);
    }
    delete(associatedItem, name, id) {
        if (this.storage[name] && this.storage[name][id]) {
            this.storage[name][id].delete(associatedItem);
        }
    }
    updateId(modelName, oldId, newId) {
        if (oldId === null) {
            throw Error('Error: no initial id');
        }
        else if (this.storage[modelName] && this.storage[modelName][oldId]) {
            const set = this.storage[modelName][oldId];
            this.storage[modelName][oldId] = null;
            this.storage[modelName][newId] = set;
        }
    }
    areArgumentsCorrect(name, id) {
        return ![name, id].some(element => element === null || typeof element === 'undefined');
    }
    isContained(name, id) {
        return Boolean(this.storage[name] && this.storage[name][id]);
    }
    throwError(name, id) {
        const error = new Error('Error: no valid data given.');
        throw Object.assign(error, {
            details: {
                name,
                id,
            },
        });
    }
}
exports.default = AssociationsStorage;
//# sourceMappingURL=../../src/associationsStorage.js.map